import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-switch',
    templateUrl: './switch.component.html',
    styleUrls: ['./switch.component.scss']
})
export class SwitchComponent implements OnInit, OnDestroy {

    @Input() control: FormControl;
    @Input() label: FormControl;

    @Output('valueChanged') valueChangedEvEm = new EventEmitter();

    valueChangedSub = Subscription.EMPTY;

    readonly randomId = `switch-${(1 - Math.random())}`;

    constructor() { }

    ngOnInit(): void {
        this.valueChangedSub = this.control.valueChanges.subscribe(
            value => {
                this.valueChangedEvEm.emit(value);
            }
        );
     }

    onChange(value: boolean) {

    }

    ngOnDestroy(): void {
        this.valueChangedSub.unsubscribe();
    }


    get fControl() { return this.control; }
}
